export default __webpack_public_path__ + "static/media/Screenshot (110).ef29f6d5.png";